import React from 'react';

export type Props = {
  className?: string;
  color?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

export const Play = React.memo((props: Props) => {
  const {
    width = 54,
    height = 54,
    className,
    color = '#0F0A1B',
    onClick,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox='0 0 54 54'
      fill='none'
    >
      <path fillRule='evenodd' clipRule='evenodd' d='M27 5.5C15.1259 5.5 5.5 15.1259 5.5 27C5.5 38.8741 15.1259 48.5 27 48.5C38.8741 48.5 48.5 38.8741 48.5 27C48.5 15.1259 38.8741 5.5 27 5.5ZM0.5 27C0.5 12.3645 12.3645 0.5 27 0.5C41.6355 0.5 53.5 12.3645 53.5 27C53.5 41.6355 41.6355 53.5 27 53.5C12.3645 53.5 0.5 41.6355 0.5 27Z' fill={color} />
      <path d='M21 21.4197V32.5803C21 34.11 22.6473 35.0734 23.9805 34.3235L33.9011 28.7432C35.2604 27.9785 35.2604 26.0215 33.9011 25.2568L23.9805 19.6765C22.6473 18.9266 21 19.89 21 21.4197Z' fill={color} />
      <path fillRule='evenodd' clipRule='evenodd' d='M23.7354 20.1123C22.7355 19.5499 21.5 20.2725 21.5 21.4197V32.5803C21.5 33.7275 22.7355 34.4501 23.7354 33.8877L33.6559 28.3074C34.6754 27.7339 34.6754 26.2661 33.6559 25.6926L23.7354 20.1123ZM20.5 21.4197C20.5 19.5076 22.5591 18.3033 24.2257 19.2408L34.1462 24.8211C35.8453 25.7768 35.8453 28.2232 34.1462 29.1789L24.2257 34.7592C22.5591 35.6967 20.5 34.4924 20.5 32.5803V21.4197Z' fill={color} />
    </svg>
  );
});

Play.displayName = 'Play';
